import { Maybe } from './globalTypes'

import { SlideType, isSlideType } from './SlideType'

import bannerFragmentRawString from '../../fragments/BannerFragment.graphql'

export const bannerFragmentString = bannerFragmentRawString

export type BannerFragment = {
  __typename: 'ComponentSectionsBannerSlider'
  slides: Maybe<Maybe<SlideType>[]>
}

export const isBannerFragment = (fragment: any): fragment is BannerFragment =>
  fragment &&
  fragment.__typename === 'ComponentSectionsBannerSlider' &&
  (fragment.slides === null ||
    (Array.isArray(fragment.slides) &&
      fragment.slides
        .slice(0, 5)
        .reduce(
          (accum: any, next: any) =>
            accum && (next === null || (isSlideType(next) as boolean)),
          true,
        )))
